// import React from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";

const DrVikramSinghcontent = () => {
  return (
    <>
      <Header />
      <div style={{ backgroundColor: "#fff9ee", padding: "40px 20px", paddingTop: "120px" }}>

             <div
                className="doctor-intro-container"
                style={{
                  maxWidth: "1100px",
                  margin: "auto",
                  display: "flex",
                  flexWrap: "wrap",
                  justifyContent: "center",
                  alignItems: "flex-start",
                  gap: "32px",
                  textAlign: "left",
                }}
              >

               <img
                 src="/Doctorprofile.png"
                 alt="Dr. Aaradhya Sharma"
                 style={{
                   width: "220px",
                   height: "220px",
                   borderRadius: "50%",
                   objectFit: "cover",
                   border: "3px solid #ddd",
                   flexShrink: 0,
                 }}
               />
           
               <div
                 className="vertical-divider"
                 style={{
                   width: "2px",
                   backgroundColor: "#ccc",
                   height: "100%",
                   minHeight: "160px",
                   display: "none",
                 }}
               ></div>
           
               <div
                 style={{
                   display: "flex",
                   flexDirection: "column",
                   gap: "16px",
                   flex: 1,
                   minWidth: "260px",
                 }}
               >
                 <div
                   style={{
                     display: "flex",
                     flexDirection: "column",
                     gap: "16px",
                   }}
                   className="content-container"
                 >
                   <div
                     style={{
                       display: "flex",
                       flexDirection: "column",
                       gap: "16px",
                     }}
                     className="inner-content"
                   >
                     
                     <div style={{ flex: 1 }}>
                       <h2 style={{ fontWeight: "bold", marginBottom: "8px" }}>
                         Dr. Vikram Singh
                       </h2>
                       <p style={{ margin: "4px 0", color: "#333" }}>
                         <strong>Specialization:</strong> Your Expert & Confidante
                       </p>
                       <p style={{ margin: "4px 0", color: "#333" }}>
                         <strong>Experience:</strong> 16 Years
                       </p>
                       <p style={{ margin: "4px 0", color: "#333" }}>
                         <strong>Degrees:</strong> MBBS, DGO (Obs & Gyn
                       </p>
                     </div>
                       <div
                         className="vertical-divider"
                         style={{
                           width: "2px",
                           backgroundColor: "#ccc",
                           height: "100%",
                           minHeight: "160px",
                           display: "none",
                         }}
                       ></div>
                     
                     <div style={{ flex: 1 }}>
                       <p
                         style={{
                           fontStyle: "italic",
                           fontSize: "15px",
                           lineHeight: "1.6",
                           color: "#444",
                           marginTop: "4px",
                         }}
                       >
                         "Knowledge is power, especially in pregnancy. My mission is to demystify the
                          process, replacing your fear of the unknown with the confidence of understanding."
                       </p>
                     </div>
                   </div>
                 </div>
               </div>
             </div>
           </div>

              <style>
                  {`
                    @media (min-width: 768px) {
                      .vertical-divider {
                        display: block !important;
                      }
                
                      .inner-content {
                        flex-direction: row !important;
                      }
                    }
                
                    @media (max-width: 767px) {
                      .doctor-intro-container {
                        flex-direction: column;
                        align-items: center !important;
                        text-align: center !important;
                      }
                
                      .inner-content {
                        flex-direction: column !important;
                        align-items: center !important;
                        text-align: center !important;
                      }
                
                      .content-container {
                        align-items: center !important;
                        text-align: center !important;
                      }
                    }
                  `}
                </style>

   
         <div style={{ padding: "40px 20px", maxWidth: "1100px", margin: "auto" }}>
           <h3>My Philosophy on Pregnancy Care:</h3>
           <p style={{ marginTop: "12px", lineHeight: "1.6", color: "#444" }}>
             I see myself as a translator and an educator. The world of
             medicine can be intimidating. I break down complex information into simple, understandable
             terms. I believe in empowering you to make informed decisions about your body and your baby.
             No question is too small or too basic. My greatest satisfaction comes from seeing a mother's
             anxiety melt away as she gains a clear understanding of her own journey.
           </p>
   
           <h3 style={{ marginTop: "32px" }}>Why I Chose Myprega:</h3>
           <p style={{ marginTop: "12px", lineHeight: "1.6", color: "#444" }}>
             The educational material and proactive communication that Myprega
             provides is revolutionary. They have built the framework I always wished I had—a way to
             consistently educate and support mothers outside the limited time of an appointment. We are
             truly proactive here, not just reactive
           </p>
   
           <h3 style={{ marginTop: "32px" }}>Beyond the Clinic:</h3>
           <p style={{ marginTop: "12px", lineHeight: "1.6", color: "#444" }}>
             I'm a history buff and love listening to podcasts on my commute. I also
             practice mindfulness meditation daily, which helps me stay present and focused, both in my
             personal life and with my patients. I'm currently reading "Sapiens" by Yuval Noah Harari.
           </p>
         </div>
          <div style={{ backgroundColor: "#f9f7f2", padding: "40px 20px" }}>
            <div
            className="doctor-intro-container"
              style={{
                maxWidth: "1100px",
                margin: "auto",
                display: "flex",
                flexWrap: "wrap",
                justifyContent: "space-between",
                alignItems: "flex-start",
                gap: "24px",
                paddingTop: "32px",
              }}
            >
              {/* Favourite Book */}
              <div style={{ flex: 1, minWidth: "250px" }}>
                <p style={{ fontWeight: "bold", marginBottom: "4px" }}>
                  📖 Favourite Book
                </p>
                <p style={{ color: "#333" }}>
                  Sapiens - A Brief History of Humankind
                </p>
              </div>
          
              {/* Divider */}
              <div
                className="vertical-divider"
                style={{
                  width: "1px",
                  backgroundColor: "#ccc",
                  height: "auto",
                  minHeight: "50px",
                  alignSelf: "stretch",
                  display: "none",
                }}
              ></div>
          
              {/* Favourite Singer */}
              <div style={{ flex: 1, minWidth: "250px" }}>
                <p style={{ fontWeight: "bold", marginBottom: "4px" }}>
                  🎵 Favourite Singer
                </p>
                <p style={{ color: "#333" }}>Lata Mangeshkar</p>
              </div>
          
              {/* Divider */}
              <div
                className="vertical-divider"
                style={{
                  width: "1px",
                  backgroundColor: "#ccc",
                  height: "auto",
                  minHeight: "50px",
                  alignSelf: "stretch",
                  display: "none",
                }}
              ></div>
          
              {/* Favourite Pastime */}
              <div style={{ flex: 1, minWidth: "250px" }}>
                <p style={{ fontWeight: "bold", marginBottom: "4px" }}>
                  🍽️ Favourite Pastime
                </p>
                <p style={{ color: "#333" }}>
                  Semi-classical music, <br />
                  Gardening
                </p>
              </div>
            </div>
          </div>
      <Footer />
    </>
  );
};

export default DrVikramSinghcontent;
